import { useStorage } from '@vueuse/core'

const STORE_NAME = 'userSettings'
const FILTERS_VALUES_KEY_SUFFIX = '_filters_values'
const COLUMNS_KEY_SUFFIX = '_columns'
const CONTACT_STORAGE_NAME = 'contactSettings'

export function getFiltersValuesKey(storageKey: string) {
  return `${storageKey}${FILTERS_VALUES_KEY_SUFFIX}`
}

export function getColumnsKey(storageKey: string) {
  return `${storageKey}${COLUMNS_KEY_SUFFIX}`
}

export function getTipsKey(storageKey: string) {
  return `should_skip_${storageKey}_tips`
}

export function getPdfExportFieldsKey(storageKey: string) {
  return `${storageKey}_pdf_export_fields`
}

function setFiltersValues(
  sourceFiltersValues: { [key: string]: any },
  filtersValues: { [key: string]: any },
  keyPrefix = ''
) {
  Object.keys(sourceFiltersValues).forEach((originKey) => {
    const value = sourceFiltersValues[originKey]
    const key = `${keyPrefix}${originKey}`

    if (Array.isArray(value)) {
      if (value.length > 0 && value[0]?.value !== undefined) {
        filtersValues[key] = value.map((option) => option.value)
      } else {
        filtersValues[key] = value === null ? [] : value
      }
    } else if (value && typeof value === 'object') {
      setFiltersValues(value, filtersValues, `${key}.`)
    } else {
      filtersValues[key] = value === '' || value === null ? [] : [value]
    }
  })
}

export const useUserSettingsStore = defineStore(STORE_NAME, {
  state: () => {
    const userStore = useUserStore()
    const settings = useStorage(userStore.isLoggedIn ? STORE_NAME : CONTACT_STORAGE_NAME, {}) as any

    if (!userStore.isLoggedIn) {
      settings.value = {}
    }

    return {
      settings: settings as any,
      isFetched: false
    }
  },
  actions: {
    getUserSettings(key?: string) {
      return key && __.get(this.settings, key)
    },
    updateUserSettings(key: string | undefined, value: any) {
      if (!key) {
        return
      }
      __.set(this.settings, key, value)

      if (useUserStore().isLoggedIn) {
        useApi('user-settings', 'PUT', {
          property: key,
          settings: value
        })
      }
    },
    getFiltersValues(storageKey: string): { [key: string]: any } {
      const filtersValues = {}
      setFiltersValues({ ...this.settings[getFiltersValuesKey(storageKey)] }, filtersValues)
      return filtersValues
    },
    async fetchUserSettings() {
      if (!this.isFetched && __.isEmpty(this.settings)) {
        this.settings = await useApi('user-settings', 'GET')
        this.isFetched = true
      }
    }
  }
})
